// extracted by mini-css-extract-plugin
export var starRatings = "index-module--star-ratings--0f11f";
export var starRatingsRating = "index-module--star-ratings-rating--2a327";